import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
//files
import { useStyles } from '../updateBatchStyles';
import UpdateBMRData from './UpdateBMRData';
import GetAppIcon from "@material-ui/icons/GetApp";
import { ReactComponent as StructureIcon } from "./../../../../../layout/icons/smc_fill.svg";
import StyledButton from '../../../../models/Button';
import { getFeaturesAccess } from '../../../../../../containers/actions/common/accessControl';
import { useDispatch, useSelector } from 'react-redux';

const ConsumptionInformationSection = (props) => {
  const classes = useStyles();
const dispatch =useDispatch();
  const [consumptionView, setConsumptionView] = useState(false);

    const screenAccess = useSelector(
      (state) =>
        state.pcmp.common.accessControl.screensAccess.data.fgBatch
    );
  
    const featuresAccess = useSelector(
      (state) =>
        state.pcmp.common.accessControl.featuresAccess.fgBatch
      // (state) => state.pcmp.common.accessControl.featuresAccess
    );

    useEffect(() => {
      if (screenAccess?.screenAccess && !featuresAccess)
        dispatch(
          getFeaturesAccess(screenAccess?.screenId, "fgBatch")
        );
      // We can pick up DS screen Id from access screensAccess.data.deliverySchedule.screenId
    }, [dispatch, screenAccess, featuresAccess]);


  const handleViewUpdate = () => {
    setConsumptionView(true);
  };

  const handleCloseView = () => {
    setConsumptionView(false);

    if (props.consumptionScreen) {
      props.handleConsumptionDialog();
    }
  };

  const getLatestFile = (files) => {
    if (!files || files.length === 0) return null; // Handle empty array
    return files.reduce((latest, current) => {
        return new Date(current.lastUpdatedDate) > new Date(latest.lastUpdatedDate) ? current : latest;
    });
  };
  
  
  let bmrFile = props.batchDetails.existingCustomFiles && Array.isArray(props.batchDetails.existingCustomFiles) 
  ? props.batchDetails.existingCustomFiles.filter((val)=> val?.customFileType === 'BMR') : []

  // console.log(bmrFile)
let latestFile = getLatestFile(bmrFile);


// console.log((latestFile) ? latestFile.schrockenCustomFileID : '')

  return (
    <React.Fragment>
      <Grid container>
        <Grid item xs={12} sm={12} md={6} className={classes.grid}>
          {/* <Typography variant='body2' className={classes.font}>
            Consumption Information Status
                  </Typography> */}
                  {(props.batchDetails.bomConsumptionAddedIndicator === true && latestFile !== null ) && (
            <Typography
              variant='body2'
              className={classes.fontPadding}
              onClick={handleViewUpdate}
              style={{
                paddingTop: '0.25rem',
                fontSize: '1rem',
                color: 'blue',
                textDecoration: 'underline',
                cursor:'pointer',
              }}
            >
              Check consumption table
            </Typography>
                  )} 
                  
                  {(props.batchDetails.bomConsumptionAddedIndicator === true && latestFile !== null )  && (
                      <Grid item xs={12} style={{ display: "flex", alignItems: "center" }}>
                      <GetAppIcon fontSize="small" style={{ color: "blue" }} onClick={() => props.handleDownloadFile(latestFile.schrockenCustomFileID)} />
                      <Typography
                        variant={"body2"}
                        className={classes.fontPadding}
                        style={{
                            paddingTop: '0.25rem',
                            fontSize: '1rem',
                            color: 'blue',
                            textDecoration: 'underline',
                            cursor:'pointer',
                          }}
                          onClick={() => props.handleDownloadFile(latestFile.schrockenCustomFileID)}
                      >
                        Consumption_pages.json
                      </Typography>
                      <StructureIcon
                        style={{ cursor: "pointer" }}
                        onClick={() => handleViewUpdate()}
                      />
                      </Grid>
                      
            )}
          
          {(latestFile === null) && (
            <Typography
              variant='body2'
              className={classes.fontPadding}
              style={{
                paddingTop: '0.25rem',
                fontSize: '1rem',
              }}
            >
              -Not Uploaded yet -
            </Typography>
          )}

{/* {(props.batchDetails.bomConsumptionAddedIndicator === false && latestFile !== null) && (
            <Typography
              variant='body2'
              className={classes.fontPadding}
              style={{
                paddingTop: '0.25rem',
                fontSize: '1rem',
                color: 'red',
              }}
            >
              Note - Processing in progress
            </Typography>
          )} */}
        </Grid>

      
        {(localStorage.collabType === 'CMO' && localStorage.organizationName === "Patheon" &&
        (props.batchDetails.SASLBatchStatusID === 13 || props.batchDetails.SASLBatchStatusID <= 5 ) && featuresAccess?.fgBatchUploadBMR) &&
         (
          <Grid item xs={12} sm={12} md={6} className={classes.grid}>
            <StyledButton
              // startIcon={
              //   localStorage.collabType === 'CMO' && (
              //     <CreateIcon
              //       style={{
              //         fontSize: 15,
              //       }}
              //     />
              //   )
              // }
              className={classes.export}
              onClick={handleViewUpdate}
              // onClick={handleUpdate}
            >
              Upload through BMR scan
            </StyledButton>
          </Grid>
         )}
      </Grid>

      {(props.consumptionScreen || consumptionView) &&
         <UpdateBMRData
         {...props}
         open={props.consumptionScreen || consumptionView}
         onClose={handleCloseView}
       handleClose={handleCloseView}
         // handleFetchCall={props.handleFetchCall}
         schrockenCustomFileID={(latestFile) ? latestFile.schrockenCustomFileID : ''}
         batchDetails={props.batchDetails}
              targetQuantity={props.targetQuantity}
              viewFlag={true}
       />
      }
     

    </React.Fragment>
  );
};

export default ConsumptionInformationSection;
